import { backofficeRequest } from '../../../axios'

export const fetchTemplatesByType = async (template_type) => {
  try {
    const response = await backofficeRequest.get(
      `backoffice/templates/type/${template_type}`
    )
    return response.data
  } catch (error) {
    return error
  }
}
